import { supportedSystemPositions } from "@/Common/helpers/Positions";
import ACTIONS from "@/Constants/actionsList";
const POSITIONS = supportedSystemPositions();
// API's
//Sales Departmental
import {
	//Queries
	getSalesDepartmentalPayPlan,
	getSalesDepartmentalPayPlans,
	getSalesDepartmentalPayPlanMatches,
	getSalesDepartmentalPayPlansSidebarTree,
	//Mutations
	createSalesDepartmentalPayPlan,
	updateSalesDepartmentalAvailablePayPlan,
	cloneSalesDepartmentalPayPlan,
	deleteSalesDepartmentalPayPlan,
	updateSalesDepartmentalPayPlan,
	saveNewSalesDepartmentalPayPlan,
	//Subscriptions
	onCloneSalesDepartmentalPayPlan,
	onCreateSalesDepartmentalPayPlan,
	onDeleteSalesDepartmentalPayPlan,
	onUpdateSalesDepartmentalAvailablePayPlan,
	onUpdateSalesDepartmentalPayPlan,
} from "@/PayPlans/api/managers/sales";

const EDIT_ACTIONS = new Map([
	[POSITIONS.SALES.SALES_MANAGER, ACTIONS.EDIT_SALES_MANAGER_PAY_PLANS],
	[POSITIONS.SALES.GENERAL_SALES_MANAGER, ACTIONS.EDIT_GENERAL_SALES_MANAGER_PAY_PLANS],
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, ACTIONS.EDIT_FINANCE_DIRECTOR_PAY_PLANS],
]);

const getDepartmentalEditActions = (position: string) => {
	return {
		editable: EDIT_ACTIONS.get(position) ?? "",
	};
};

const getSalesDepartmentalServices = (position: string) => {
	// Auth actions
	const actions = getDepartmentalEditActions(position);

	const getPayPlan = async (locationId: string, id: string, extraPosition: string) =>
		getSalesDepartmentalPayPlan(locationId, id, extraPosition || position);
	const getMatches = async (locationId: string, id: string, extraPosition: string) =>
		getSalesDepartmentalPayPlanMatches(locationId, id, extraPosition || position);

	// API Queries
	const queries = {
		getPayPlan,
		getMatches,
		getPayPlans: getSalesDepartmentalPayPlans,
		getPayPlansSidebarTree: getSalesDepartmentalPayPlansSidebarTree,
	};

	// API Mutations
	const mutations = {
		addPayPlan: createSalesDepartmentalPayPlan,
		saveNewPayPlan: saveNewSalesDepartmentalPayPlan,
		updatePayPlan: updateSalesDepartmentalPayPlan,
		deletePayPlan: deleteSalesDepartmentalPayPlan,
		clonePayPlan: cloneSalesDepartmentalPayPlan,
		updateAvailablePayPlan: updateSalesDepartmentalAvailablePayPlan,
	};

	// API Subscriptions
	const subscriptions = new Map([
		["onClonePayPlan", { query: onCloneSalesDepartmentalPayPlan, getter: "onCloneSalesDepartmentalPayPlan" }],
		["onCreatePayPlan", { query: onCreateSalesDepartmentalPayPlan, getter: "onCreateSalesDepartmentalPayPlan" }],
		["onDeletePayPlan", { query: onDeleteSalesDepartmentalPayPlan, getter: "onDeleteSalesDepartmentalPayPlan" }],
		["onUpdatePayPlan", { query: onUpdateSalesDepartmentalPayPlan, getter: "onUpdateSalesDepartmentalPayPlan" }],
		["onUpdateAnyPayPlan", { query: "", getter: "" }],
		[
			"onUpdateAvailablePayPlan",
			{ query: onUpdateSalesDepartmentalAvailablePayPlan, getter: "onUpdateSalesDepartmentalAvailablePayPlan" },
		],
	]);

	return {
		actions,
		queries,
		mutations,
		subscriptions,
	};
};

export { getSalesDepartmentalServices };
